/*
 * Adobe Experience Cloud shell bootstrap — Surprise2Refine UI only (no React shell).
 */
import './consoleSilence.js'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import $ from 'jquery'
import Runtime, { init } from '@adobe/exc-app'
import { setSurpriseRuntimeConfig } from '../surprise/apiConfig.js'
import { buildActionUrlsFromEnv } from '../surprise/buildActionUrls.js'

window.jQuery = window.$ = $

function bootstrapInExcShell () {
  const runtime = Runtime()
  runtime.solution = {
    icon: 'AdobeExperienceCloud',
    title: 'Surprise2Refine',
    shortTitle: 'S2R'
  }
  runtime.title = 'Surprise2Refine'
  runtime.on('ready', () => {
    runtime.done()
    setSurpriseRuntimeConfig({
      urls: buildActionUrlsFromEnv()
    })
    import('../surprise/app.js')
  })
}

function bootstrapRaw () {
  setSurpriseRuntimeConfig({
    urls: buildActionUrlsFromEnv()
  })
  import('../surprise/app.js')
}

try {
  require('./exc-runtime')
  init(bootstrapInExcShell)
} catch (e) {
  console.warn('application not running in Adobe Experience Cloud Shell', e)
  bootstrapRaw()
}
